import { Box, ClipboardList, History, Info, type LucideIcon } from 'lucide-react';
import { cn } from '@/utils/cn';

interface TabItem {
  id: string;
  label: string;
  icon: LucideIcon;
}

const tabs: TabItem[] = [
  { id: 'detail', label: 'Thông tin chi tiết', icon: Info },
  { id: 'stock', label: 'Tồn kho', icon: Box },
  { id: 'history', label: 'Lịch sử nhập - xuất', icon: History },
  { id: 'usage', label: 'Sử dụng trong dự án', icon: ClipboardList },
];

interface InventoryDetailTabsProps {
  activeTab: string;
  setActiveTab: (id: string) => void;
}

export function InventoryDetailTabs({ activeTab, setActiveTab }: InventoryDetailTabsProps) {
  return (
    <div className="flex border-b border-slate-200">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={cn(
            'flex items-center gap-2 px-6 py-4 sm:text-sm text-xs transition-all border-b-2',
            activeTab === tab.id
              ? 'border-emerald-600 text-emerald-600 bg-emerald-50/50 font-medium'
              : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'
          )}
        >
          <tab.icon className="h-4 w-4" />
          {tab.label}
        </button>
      ))}
    </div>
  );
}
